import { Link } from "react-router-dom";
import { Tooltip } from "@/components/ui/tooltip";
import { SyncState, timeAgoByMax } from "@moonscape/shared";
import React from "react";
import { Tag } from "@/components/ms";

export const ExchangeStatus = ({exchange}) => {
    // exchange?.integration?.sync_status?.updated_at
  switch (exchange?.integration?.sync_status?.status) {
    case SyncState.SYNCING:
    case SyncState.PROCESSING:
      return (
        <Tooltip
          placement="top"
          title={
            <div>
              <div className="flex flex-col gap-4">
                <div>
                  <strong>{`${String(exchange?.integration?.exchangename || "Exchange")} Syncing`}</strong>
                </div>
                <div className="flex flex-col gap-2">
                  {timeAgoByMax(exchange?.lastSynced) && (
                    <div>{`Last updated ${timeAgoByMax(exchange?.lastSynced)} ago`}</div>
                  )}
                  <div>{`Status: ${String(exchange?.integration?.sync_status?.status || "Unknown")}`}</div>
                </div>
              </div>
              <div className="mt-4">
                <div>
                  <strong>Need Assistance?</strong>
                </div>
                <div>
                  If you have any questions or run into any issues, please don’t
                  hesitate to reach out to our support team at{" "}
                  <strong>hello@moonscape.app</strong>. We’re here to help!
                </div>
              </div>
            </div>
          }
        >
          <Tag tone="live">
            <span className="mr-0.5 inline-block h-[5px] w-[5px] animate-pulse rounded-full bg-ms-rule" />
            Importing
          </Tag>
        </Tooltip>
      );
    case SyncState.FAILED:
      return (
        <Tooltip
          placement="top"
          title={
            <div>
              <div className="flex flex-col gap-4">
                <div>
                  <strong>API key error</strong>
                </div>
                {exchange?.status && <div>{typeof exchange.status === 'string' ? exchange.status : JSON.stringify(exchange.status)}</div>}
              </div>
              <div className="mt-4">
                <div>
                  <strong>Need Assistance?</strong>
                </div>
                <div>
                  If it's your mistakes in API key permission, expired or
                  something like that. Please recreate a new API key and update{" "}
                  <Link
                    to="/settings/exchange/new"
                    className="underline font-medium"
                  >
                    here
                  </Link>
                  . If you have any questions or run into any issues, please
                  don’t hesitate to reach out to our support team at{" "}
                  <strong>hello@moonscape.app</strong>. We’re here to help!
                </div>
              </div>
            </div>
          }
        >
          <Tag tone="neg">Reconnect</Tag>
        </Tooltip>
      );
    case SyncState.COMPLETED:
      return (
        <Tooltip
          placement="top"
          title={
            <div>
              <div className="flex flex-col gap-4">
                <div>
                  <strong>{`${String(exchange?.name || "Exchange")} Sync Detail`}</strong>
                </div>
                <div className="flex flex-col gap-2">
                  {timeAgoByMax(exchange?.lastSynced) && (
                    <div>{`Last synced ${timeAgoByMax(exchange?.lastSynced)} ago`}</div>
                  )}
                  <div>{`Status: ${String(exchange?.syncStatus || "Unknown")}`}</div>
                  <div>Next sync: every 24h</div>
                </div>
              </div>
              <div className="mt-4">
                <div>
                  <strong>Need Assistance?</strong>
                </div>
                <div>
                  If you have any questions or run into any issues, please don’t
                  hesitate to reach out to our support team at{" "}
                  <strong>hello@moonscape.app</strong>. We’re here to help!
                </div>
              </div>
            </div>
          }
        >
          <Tag tone="pos">Synced</Tag>
        </Tooltip>
      );
    default:
      return <></>;
  }
};
